import { render, staticRenderFns } from "./FormDrawer.vue?vue&type=template&id=4b618f19&scoped=true&"
import script from "./FormDrawer.vue?vue&type=script&lang=js&"
export * from "./FormDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b618f19",
  null
  
)

export default component.exports